// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__onfVH","toggle":"styles_toggle__2_mGO","preview":"styles_preview__13myE"};